import BoldReportsViewer from './boldReportsViewer';
import { BoldReportsViewerProps } from './boldReportsViewer';

export {
    BoldReportsViewer,
    BoldReportsViewerProps
}